module.exports = __webpack_public_path__ + "static/media/swipe-hand.b4c31be9.svg";